import React from 'react';
import { Box } from '@mui/material';
import palette from '@ui/palette';
import Typography from '@ui/Typography';
import { makeStyles } from 'tss-react/mui';
import Icon, { IconType } from '@ui/Icon';

const useStyles = makeStyles()(theme => ({
  uploadIcon: {
    background: palette.gray_600,
    height: 40,
    width: 40,
    margin: '0 auto',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chooseFile: {
    background: 'transparent',
    border: 'none',
    padding: 0,
    margin: 0,
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
    font: 'inherit',
    '&:focus-visible': {
      textDecorationColor: palette.mint_200,
    },
  },
  fileTypes: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 8,
  },
  fileTypeTag: {
    background: palette.gray_800,
    borderRadius: 4,
    padding: '2px 8px',
  },
}));

type EmptyZoneProps = {
  accept: string;
  onChooseFile: () => void;
};

const EmptyZone = ({ accept, onChooseFile }: EmptyZoneProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Box paddingBottom={1.5}>
        <Box className={classes.uploadIcon}>
          <Icon type={IconType.upload01} style={{ width: 24, height: 24 }} />
        </Box>
      </Box>

      <Typography variant="pMd" color="primary">
        Drag & drop, or{' '}
        <button
          type="button"
          onClick={onChooseFile}
          className={classes.chooseFile}
          data-e2e="dropzone-file-selection"
        >
          choose a file
        </button>
      </Typography>

      <Box marginTop={1.5} className={classes.fileTypes}>
        {accept.split(',').map(type => (
          <Box key={type} className={classes.fileTypeTag}>
            <Typography variant="pXs" color="gray_300" bold>
              {type.replace('.', '').toUpperCase().trim()}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default EmptyZone;
